export default "__VITE_ASSET__DBSRd7f3__"